module.exports = __webpack_public_path__ + "img/sparks-green-s.433820b6.png";